<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Regulaminy</span>
        <h3 class="page-title">Lista regulaminów</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          v-if="userData.role === 'R_ADMIN' || userData.role === 'R_DEPUTY_DIRECTOR' || userData.role === 'R_HR' || userData.role === 'R_ACCOUNTANT' || userData.role === 'R_RECEPTION'"
          theme="success"
          @click.prevent="$router.push('/regulaminy/dodaj')">
          <i class="material-icons">add</i>
          Dodaj regulamin
        </d-button>
      </d-col>
    </d-row>
    <d-row
      v-if="loaded"
      style="width: 100%;"
      class="d-flex ml-0 mb-3 page-filters">
      <validation-observer
        ref="regulations-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">
        <d-input
          placeholder="Podaj nazwę dokumentu"
          v-model="filters.search" />
        <d-button
          theme="info"
          outline
          class="text-nowrap ml-2"
          @click.prevent="validateFiltersForm">Szukaj</d-button>
        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          @click.prevent="clearFilters">Resetuj filtry</d-button>
      </validation-observer>
    </d-row>
    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
        <tr>
          <th scope="col" class="border-0">Nazwa regulaminu</th>
          <th scope="col" class="border-0">Krótki opis</th>
          <th scope="col" class="border-0">Plik do pobrania</th>
          <th scope="col" class="border-0">Akcje</th>
        </tr>
        </thead>
        <tbody v-if="loaded">
        <tr
          v-for="(regulation, index) of regulations"
          :key="'user-' + index">
          <td class="align-middle">
            {{ regulation.name }}
          </td>
          <td class="align-middle">
            {{ regulation.description }}
          </td>
          <td class="align-middle" style="width: 200px">
            <d-button
              theme="info"
              class="mr-2"
              outline
              :disabled="downloading !== false"
              @click.prevent="download(regulation.id, regulation.filename)">
              <template v-if="downloading !== regulation.filename"><i class="material-icons">cloud_download</i><span class="ml-2">Pobierz</span></template>
              <template v-else>
                <div class="spinner-border spinner-border-sm" role="status"></div>
              </template>
            </d-button>
          </td>
          <td
            class="align-middle"
            style="width: 150px;">
            <d-button
              :disabled="userData.role !== 'R_ADMIN' && userData.role !== 'R_DEPUTY_DIRECTOR' && userData.role !== 'R_HR' && userData.role !== 'R_ACCOUNTANT' && userData.role !== 'R_RECEPTION'"
              theme="primary"
              @click.prevent="$router.push('/regulaminy/edycja/' + regulation.id)"
              class="mr-2"
              title="Edytuj">
              <i class="material-icons">edit</i>
            </d-button>
            <d-button
              theme="danger"
              :disabled="removeInProgress || (userData.role !== 'R_ADMIN' && userData.role !== 'R_DEPUTY_DIRECTOR' && userData.role !== 'R_HR' && userData.role !== 'R_ACCOUNTANT' && userData.role !== 'R_RECEPTION')"
              @click.prevent="removeRegulation(regulation.id)"
              title="Usuń">
              <i class="material-icons">delete</i>
            </d-button>
          </td>
        </tr>
        <tr v-if="regulations.length === 0">
          <td
            colspan="5"
            class="text-center">
            Brak regulaminów do wyświetlenia&hellip;
          </td>
        </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>

    <pagination :meta-data="paginationMetaData" />
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from '../utils/FormUtils.js';
import HasFilters from '../mixins/HasFilters.vue';
import HasPagination from '../mixins/HasPagination.vue';
import ListUtils from '../utils/ListUtils.js';
import Pagination from '../components/common/Pagination.vue';
import Vue from 'vue';
import axios from 'axios'
import api from '@/api'

export default {
  name: 'EDocuments',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  data() {
    return {
      regulations: [],
      categories: [],
      downloading: false,
      loaded: false,
      loadError: false,
      removeInProgress: false,
      filters: {
        search: ''
      }
    };
  },
  computed: {
    userData () {
      return this.$store.getters.getAccount
    }
  },
  mounted () {
    this.loadRegulations();
    this.accountGet();
  },
  methods: {
    accountGet () {
      this.$store.dispatch('userAccountGet')
    },
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadRegulations();
    }, 250),
    loadRegulations () {
      let where = {
        search: this.filters.search
      };
      ListUtils.loadItemsData(this, {
        endpoint: '/regulations/items?page=' + this.currentPage,
        listField: 'regulations',
        pagination: true,
        params: {
          where
        }
      });
    },
    clearFilters () {
      this.loaded = false;
      this.loadError = false;
      this.filters = {
        search: ''
      };

      this.loadRegulations();
      this.$bus.$emit('view-filters-reset');
    },
    validateFiltersForm () {
      this.$bus.$emit('pagination-reset');
      FormUtils.validate(this.$refs['regulations-filters-form'], this.debouncedLoadFilteredData);
    },
    download (regulationID, name) {
      this.downloading = true;
      let filename = name;
      axios({
        url: `${api}regulations/get-file/` + regulationID,
        method: 'POST',
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        this.downloading = false;
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas pobierania',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
        });
        this.downloading = false;
      });
    },
    removeRegulation (regulationID) {
      this.removeInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/regulations/delete/',
        id: regulationID,
        successTitle: 'Usunięto regulamin',
        successText: 'Wybrany regulamin został usunięty',
        confirmTitle: 'Czy na pewno chcesz usunąć ten regulamin?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie regulaminu nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadRegulations();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>

